import classNames from 'classnames';
import React, { FC, UIEvent, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './styles.module.css';

type BodyProps = {
  fullWidth?: boolean;
  contentClassName?: string;
  children?: React.ReactNode;
};

export const Body: FC<BodyProps> = ({
  fullWidth = false,
  children,
  contentClassName,
  ...restOfProps
}) => {
  const { pathname } = useLocation();
  const handleScroll = (e: UIEvent<HTMLDivElement>) => {
    // assigning this type because we know it is an HTMLDivElement
    const el: HTMLDivElement = e.target as HTMLDivElement;
    const body = document.querySelector('body');
    if (el.scrollTop > 10) {
      body?.classList.add('scrolled');
    } else {
      body?.classList.remove('scrolled');
    }
  };

  useEffect(() => {
    const body = document.querySelector('body');
    body?.classList.remove('scrolled');
  }, [pathname]);

  return (
    <div
      {...restOfProps}
      className={styles.container}
      onScroll={(e) => handleScroll(e)}
    >
      <div
        className={classNames(
          styles.bodyContent,
          {
            [styles.fullWidth]: fullWidth,
          },
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};
